import axios from '../utils/request'
// 发送验证码
export const getmessage = () => axios.post('index/systemInfo')
